import clsx from 'clsx';

/**
 * ProgressBar — labeled horizontal bar.
 *
 * Props:
 *   label, value, percent — required
 *   color  - CSS color for the fill (one of the few legit dynamic styles)
 */
export function ProgressBar({ label, value, percent, color, className = '' }) {
  return (
    <div className={clsx('mb-3 font-sans', className)}>
      <div className="flex justify-between mb-1.5">
        <span className="text-xs text-body font-medium">{label}</span>
        <span className="text-xs font-semibold text-ink">{value}</span>
      </div>
      <div className="h-[5px] bg-inset rounded-pill overflow-hidden">
        <div
          className="h-full rounded-pill transition-[width] duration-500 ease-out"
          style={{
            width:      `${Math.min(100, Math.max(0, percent))}%`,
            background: color || 'var(--brand)',
          }}
        />
      </div>
    </div>
  );
}
